import React, { Component } from 'react'
import KeyLabel from './KeyLabel'

class KeysList extends Component {
  labels() {
    const { wrap } = this.props

    return this.props.labels.map((label, i) => (
      <KeyLabel wrap={wrap} uuid={label.uuid} key={i}>{label.name}</KeyLabel>
    ))
  }

  render() {
    const { wrap } = this.props
    // if (wrap) return(<div>{this.labels()}</div>)

    return (
      <div className={`flex items-baseline gap-[3px] ${this.props.className}`}>
        {this.labels()}
      </div>
    )
  }
}

export default KeysList;
